// extracted by mini-css-extract-plugin
export default {"err":"FormErr_err__mZUG7","shake":"FormErr_shake__4i2oQ"};